import React, { useState, useEffect, useRef, memo } from 'react';
import { Edit3, Save, X, Eye,} from 'lucide-react';

//GENERADO Y VERIFICADO CON IA
const ContenidoEnriquecido = memo(({ 
  contenido, 
  isAdmin = false, 
  onSave,
  onChange, 
  editable = true 
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [quillLoaded, setQuillLoaded] = useState(false);
  const quillRef = useRef(null);
  const editorRef = useRef(null);
  const fileInputRef = useRef(null);
  const formatsRegistered = useRef(false);

  useEffect(() => {
    if (onChange) {
      onChange({
        isEditing,
        hasUnsavedChanges: isEditing // o cualquier lógica que necesites
      });
    }
  }, [isEditing, onChange]);

  // Función para obtener el icono según el tipo de archivo
  const getFileIcon = (mimeType) => {
    if (!mimeType) return '📄';
    
    if (mimeType.includes('pdf')) return '📄';
    if (mimeType.includes('word') || mimeType.includes('document')) return '📝';
    if (mimeType.includes('excel') || mimeType.includes('spreadsheet')) return '📊';
    if (mimeType.includes('powerpoint') || mimeType.includes('presentation')) return '📊';
    if (mimeType.includes('image')) return '🖼️';
    if (mimeType.includes('video')) return '🎥';
    if (mimeType.includes('audio')) return '🎵';
    if (mimeType.includes('zip') || mimeType.includes('rar')) return '📦';
    if (mimeType.includes('text')) return '📃';
    
    return '📄';
  };

  // Función para formatear el tamaño del archivo
  const formatFileSize = (bytes) => {
    if (!bytes || bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  // Función mejorada para convertir el formato de Quill a HTML
  const convertirQuillAHTML = (contenidoQuill) => {
    try {
      //no es contenido valido para mo,strar
      if (!contenidoQuill || !Array.isArray(contenidoQuill)) {
        return '';
      }
      
      let html = '';
      
      for (let i = 0; i < contenidoQuill.length; i++) {
        const item = contenidoQuill[i];
        const siguienteItem = i < contenidoQuill.length - 1 ? contenidoQuill[i + 1] : null;
        
        const estaEnLista = siguienteItem && 
                          siguienteItem.insert === '\n' && 
                          siguienteItem.attributes && 
                          siguienteItem.attributes.list;
        
        if (item.insert !== '\n' && estaEnLista) {
          const tipoLista = siguienteItem.attributes.list;
          html += tipoLista === 'bullet' ? '<ul><li>' : '<ol><li>';
        }
        
        if (item.insert) {

          //lista de atribuitos
          if (item.insert === '\n' && item.attributes && item.attributes.list) {
            const tipoLista = item.attributes.list;
            html += '</li>' + (tipoLista === 'bullet' ? '</ul>' : '</ol>');
          } 
          //todo lo que tenga que ver con texto, atributos de texto
          else if (typeof item.insert === 'string' && item.insert !== '\n') {
            let texto = item.insert;
            
            // Aplicar formato de texto si existe
            if (item.attributes) {
              if (item.attributes.bold) texto = `<strong>${texto}</strong>`;
              if (item.attributes.italic) texto = `<em>${texto}</em>`;
              if (item.attributes.underline) texto = `<u>${texto}</u>`;
              if (item.attributes.strike) texto = `<s>${texto}</s>`;
              if (item.attributes.code) texto = `<code>${texto}</code>`;
            }
            
            const textoConSaltos = texto.replace(/\n/g, '<br>');
            html += textoConSaltos;
          } 
          //objetos
          else if (typeof item.insert === 'object') {
            //objeto drive - drive
            if (item.insert.drive) {
              const driveData = item.insert.drive;
              const fileName = driveData.fileName || 'Archivo sin nombre';
              const mimeType = driveData.mimeType || '';
              const size = driveData.size || 0;
              const downloadUrl = driveData.urlArchivo || '#';
              const viewUrl = driveData.webViewLink || '#';
              const fileIcon = getFileIcon(mimeType);

              html += `
                <div class="drive-file-container" style="display: block; margin: 12px 0; padding: 12px; background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%); border: 1px solid #e2e8f0; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.08); width: 100%;">
                  <div style="display: flex; align-items: center; gap: 12px;">
                    <div style="font-size: 24px; flex-shrink: 0;">${fileIcon}</div>
                    <div style="flex: 1; min-width: 0;">
                      <div style="font-weight: 600; color: #1e293b; margin-bottom: 2px; font-size: 14px; word-break: break-word;">
                        ${fileName}
                      </div>
                      <div style="color: #64748b; font-size: 12px; margin-bottom: 6px;">
                        ${formatFileSize(size)} • ${mimeType.split('/')[1]?.toUpperCase() || 'ARCHIVO'}
                      </div>
                    </div>
                    <div style="display: flex; gap: 6px; flex-shrink: 0;">
                      <a href="${viewUrl}" target="_blank" rel="noopener noreferrer" 
                        style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 10px; background: #3b82f6; color: white; text-decoration: none; border-radius: 5px; font-size: 11px; font-weight: 500; transition: all 0.2s;">
                        👁️ Ver
                      </a>
                      <a href="${downloadUrl}" target="_blank" rel="noopener noreferrer"
                        style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 10px; background: #10b981; color: white; text-decoration: none; border-radius: 5px; font-size: 11px; font-weight: 500; transition: all 0.2s;">
                        📥 Descargar
                      </a>
                    </div>
                  </div>
                </div>
              `;
            }
            //objeto imagen  - image
            else if (item.insert.image) {
              html += `<img src="${item.insert.image}" alt="Imagen" class="max-w-full h-auto my-2" />`;
            } 
            //objeto archivoOffline - archivoOffline
            else if (item.insert.archivoOffline) {
              const archivoData = item.insert.archivoOffline;
              
              // Usar las propiedades correctas
              const fileName = archivoData.nombre || archivoData.fileName || 'Archivo';
              const fileSize = archivoData.tamaño || archivoData.fileSize || 0;
              const fileType = archivoData.tipo || archivoData.fileType || 'archivo';
              const fileIcon = getFileIcon(fileType);
              
              html += `
                <span class="archivo-offline-container" style="display: inline-flex; align-items: center; margin: 2px 4px; padding: 4px 8px; background: linear-gradient(135deg, #fef7cd 0%, #fef3c7 100%); border: 1px solid #f59e0b; border-radius: 12px; box-shadow: 0 1px 2px rgba(0,0,0,0.1); vertical-align: middle; max-width: 250px;">
                  <span style="font-size: 14px; margin-right: 6px; flex-shrink: 0;">${fileIcon}</span>
                  <span style="flex: 1; min-width: 0;">
                    <span style="font-weight: 500; color: #92400e; font-size: 11px; display: block; line-height: 1.2; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" title="${fileName}">
                      ${fileName}
                    </span>
                    <span style="color: #b45309; font-size: 9px; display: block; line-height: 1;">
                      ${formatFileSize(fileSize)}
                    </span>
                  </span>
                  <span style="background: #f59e0b; color: white; padding: 2px 4px; border-radius: 2px; font-size: 8px; font-weight: 500; margin-left: 4px; flex-shrink: 0;">
                    📎
                  </span>
                </span>
              `;
            }
          }
        }
      }
      
      return html;
    } catch (error) {
      console.error('Error al convertir el contenido:', error);
      return '<p>Error al cargar el contenido</p>';
    }
  };

  // Cargar Quill desde CDN
  const loadQuillFromCDN = () => {
    return new Promise((resolve, reject) => {
      if (window.Quill) {
        resolve();
        return;
      }

      // Cargar CSS
      const cssLink = document.createElement('link');
      cssLink.rel = 'stylesheet';
      cssLink.href = 'https://cdn.quilljs.com/1.3.6/quill.snow.css';
      document.head.appendChild(cssLink);

      // Cargar JS
      const script = document.createElement('script');
      script.src = 'https://cdn.quilljs.com/1.3.6/quill.min.js';
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('Failed to load Quill'));
      document.body.appendChild(script);
    });
  };

  // Registrar formato personalizado para archivos en Quill
  //Estos es fundamental, esta es la vista a la hora de la edicion
  const registerCustomFormats = () => {
  if (!window.Quill || formatsRegistered.current) return;

  try {
    const Quill = window.Quill;
    const Embed = Quill.import('blots/embed');

    // 🔹 BLOT PARA ARCHIVOS DE DRIVE
    class DriveBlot extends Embed {
        static create(value) {
          const node = super.create();
          node.setAttribute('data-drive', JSON.stringify(value));
          node.classList.add('drive-file-blot');
          
          const fileName = value.fileName || 'Archivo sin nombre';
          const fileSize = value.size || 0;
          const mimeType = value.mimeType || '';
          const downloadUrl = value.urlArchivo || '#';
          const viewUrl = value.webViewLink || '#';
          const fileIcon = this.getFileIcon(mimeType);
          
          node.contentEditable = false;
          node.style.display = 'block';
          node.style.margin = '8px 0';
          node.style.lineHeight = '1';
          
          node.innerHTML = `
            <div style="display: flex; align-items: center; padding: 12px; background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%); border: 1px solid #0ea5e9; border-radius: 8px; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; box-shadow: 0 2px 4px rgba(0,0,0,0.1); cursor: default; user-select: none; max-width: 100%;">
              <div style="font-size: 20px; margin-right: 12px; flex-shrink: 0;">${fileIcon}</div>
              <div style="flex: 1; min-width: 0;">
                <div style="font-weight: 600; color: #0c4a6e; margin-bottom: 2px; font-size: 13px; word-break: break-word;" title="${fileName}">
                  ${fileName}
                </div>
                <div style="color: #0369a1; font-size: 11px;">
                  ${this.formatSize(fileSize)} • ${mimeType.split('/')[1]?.toUpperCase() || 'ARCHIVO'}
                </div>
              </div>
              <div style="display: flex; gap: 6px; flex-shrink: 0;">
                <a href="${viewUrl}" target="_blank" rel="noopener noreferrer" 
                  style="display: inline-flex; align-items: center; gap: 4px; padding: 4px 8px; background: #3b82f6; color: white; text-decoration: none; border-radius: 4px; font-size: 10px; font-weight: 500;">
                  👁️ Ver
                </a>
                <a href="${downloadUrl}" target="_blank" rel="noopener noreferrer"
                  style="display: inline-flex; align-items: center; gap: 4px; padding: 4px 8px; background: #10b981; color: white; text-decoration: none; border-radius: 4px; font-size: 10px; font-weight: 500;">
                  📥 Descargar
                </a>
                 <a href="/" target="_blank" rel="noopener noreferrer"
                  style="display: inline-flex; align-items: center; gap: 4px; padding: 4px 8px; background: #10b981; color: white; text-decoration: none; border-radius: 4px; font-size: 10px; font-weight: 500;">
                  ❌ Eliminar
                </a>
              </div>
            </div>
          `;
          
          return node;
        }

        static value(node) {
          try {
            return JSON.parse(node.getAttribute('data-drive'));
          } catch (e) {
            return { fileName: 'Archivo', size: 0, mimeType: '', urlArchivo: '#', webViewLink: '#' };
          }
        }

        static getFileIcon(mimeType) {
          if (!mimeType) return '📄';
          if (mimeType.includes('pdf')) return '📄';
          if (mimeType.includes('word') || mimeType.includes('document')) return '📝';
          if (mimeType.includes('excel') || mimeType.includes('spreadsheet')) return '📊';
          if (mimeType.includes('powerpoint') || mimeType.includes('presentation')) return '📊';
          if (mimeType.includes('image')) return '🖼️';
          if (mimeType.includes('video')) return '🎥';
          if (mimeType.includes('audio')) return '🎵';
          if (mimeType.includes('zip') || mimeType.includes('rar')) return '📦';
          if (mimeType.includes('text')) return '📃';
          return '📄';
        }

        static formatSize(bytes) {
          if (!bytes || bytes === 0) return '0 Bytes';
          const k = 1024;
          const sizes = ['Bytes', 'KB', 'MB', 'GB'];
          const i = Math.floor(Math.log(bytes) / Math.log(k));
          return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
        }
    }

    DriveBlot.blotName = 'drive';
    DriveBlot.tagName = 'div';
    DriveBlot.className = 'drive-file-blot';

    class ArchivoOfflineBlot extends Embed {
      static create(value) {
        const node = super.create();
        node.setAttribute('data-archivo', JSON.stringify(value));
        node.classList.add('archivo-offline-blot');
        
        const fileName = value.nombre || value.fileName || 'Archivo sin nombre';
        const fileSize = value.tamaño || value.fileSize || 0;
        const fileType = value.tipo || value.fileType || '';
        const fileIcon = this.getFileIcon(fileType);
        
        // Usar contentEditable=false para evitar que se pueda editar
        node.contentEditable = false;
        node.style.display = 'inline-block';
        node.style.verticalAlign = 'middle';
        node.style.margin = '2px 1px';
        node.style.lineHeight = '1';
        
        node.innerHTML = `
          <span style="display: inline-flex; align-items: center; padding: 8px 12px; background: linear-gradient(135deg, #fef7cd 0%, #fef3c7 100%); border: 1px solid #f59e0b; border-radius: 18px; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; box-shadow: 0 2px 4px rgba(0,0,0,0.15); cursor: default; user-select: none; margin: 3px 4px;">
            <span style="font-size: 16px; margin-right: 8px; flex-shrink: 0;">${fileIcon}</span>
            <span style="font-weight: 500; color: #92400e; font-size: 12px; white-space: nowrap;" title="${fileName}">
              ${fileName}
            </span>
            <span style="background: #f59e0b; color: white; padding: 3px 6px; border-radius: 10px; font-size: 9px; margin-left: 8px; flex-shrink: 0;">📎</span>
          </span>
        `;
        
        return node;
      }

      static value(node) {
        try {
          return JSON.parse(node.getAttribute('data-archivo'));
        } catch (e) {
          return { nombre: 'Archivo', tamaño: 0, tipo: '' };
        }
      }

      static getFileIcon(mimeType) {
        if (!mimeType) return '📄';
        if (mimeType.includes('pdf')) return '📄';
        if (mimeType.includes('word') || mimeType.includes('document')) return '📝';
        if (mimeType.includes('excel') || mimeType.includes('spreadsheet')) return '📊';
        if (mimeType.includes('image')) return '🖼️';
        if (mimeType.includes('zip') || mimeType.includes('rar')) return '📦';
        return '📄';
      }

      static formatSize(bytes) {
        if (!bytes || bytes === 0) return '0B';
        const k = 1024;
        const sizes = ['B', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(0)) + sizes[i];
      }
    }

    ArchivoOfflineBlot.blotName = 'archivoOffline';
    ArchivoOfflineBlot.tagName = 'span';
    ArchivoOfflineBlot.className = 'archivo-offline-blot';

    // 🔹 REGISTRAR AMBOS BLOTS
    Quill.register(DriveBlot, true);
    Quill.register(ArchivoOfflineBlot, true);

    formatsRegistered.current = true;
    console.log('✅ Formato archivoOffline registrado exitosamente');
  } catch (error) {
    console.error('❌ Error al registrar formato personalizado:', error);
  }
  };

  // Manejar subida de archivos
  const handleFileUpload = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  // Procesar archivo subido - CORREGIDO
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file || !quillRef.current) return;

    try {
      console.log('📎 Procesando archivo:', file.name, file.size, file.type);

      // Función para convertir archivo a base64
      const fileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
            const base64 = reader.result.split(',')[1];
            resolve(base64);
          };
          reader.onerror = error => reject(error);
        });
      };

      // Convertir archivo a base64
      const base64Content = await fileToBase64(file);
      
      console.log('📄 Archivo convertido a base64. Longitud:', base64Content.length);

      // CORREGIDO: Crear objeto con la estructura correcta
      const archivoData = {
        nombre: file.name,           // ✅ Nombre correcto
        contenido: base64Content,    // ✅ Contenido base64
        tipo: file.type,            // ✅ Tipo correcto  
        tamaño: file.size           // ✅ Tamaño correcto
      };

      console.log('📋 Objeto archivo creado:', {
        nombre: archivoData.nombre,
        tieneContenido: !!archivoData.contenido,
        tipo: archivoData.tipo,
        tamaño: archivoData.tamaño
      });

      // Verificar que el formato esté registrado antes de insertar
      if (!formatsRegistered.current) {
        console.error('❌ El formato archivoOffline no está registrado');
        alert('Error: El formato de archivos no está disponible');
        return;
      }

      // Insertar el archivo en el editor
      const range = quillRef.current.getSelection();
      const index = range ? range.index : quillRef.current.getLength();
      
      // CORREGIDO: Insertar con el blot personalizado
      quillRef.current.insertEmbed(index, 'archivoOffline', archivoData);
      quillRef.current.setSelection(index + 1);

      // ✅ Notificar que hay cambios pendientes
      if (onChange) {
        onChange({
          isEditing: true,
          hasUnsavedChanges: true
        });
      }

      // Limpiar input
      e.target.value = '';
      
      console.log('✅ Archivo insertado exitosamente en el editor');
      
    } catch (error) {
      console.error('❌ Error al procesar archivo:', error);
      alert('Error al procesar el archivo: ' + error.message);
    }
  };

  // Inicializar Quill cuando entra en modo edición
  const initQuill = async () => {
    if (typeof window !== 'undefined' && !quillRef.current && editorRef.current) {
      try {
        // Cargar Quill desde CDN si no está disponible
        if (!window.Quill) {
          await loadQuillFromCDN();
        }

        // Esperar un poco para asegurar que Quill esté completamente cargado
        await new Promise(resolve => setTimeout(resolve, 100));

        // Registrar formatos personalizados ANTES de crear la instancia
        registerCustomFormats();

        const Quill = window.Quill;
        
        if (!Quill) {
          console.error('Quill no pudo cargarse');
          return;
        }

        // Configurar módulo personalizado para archivos
        const toolbarOptions = [
          [{ 'header': [1, 2, 3, false] }],
          ['bold', 'italic', 'underline', 'strike'],
          [{ 'list': 'ordered'}, { 'list': 'bullet' }],
          ['blockquote', 'code-block'],
          ['link'],
          ['upload-file'], // Botón personalizado para archivos
          ['clean']
        ];

        quillRef.current = new Quill(editorRef.current, {
          theme: 'snow',
          modules: {
            toolbar: {
              container: toolbarOptions,
              handlers: {
                'upload-file': handleFileUpload
              }
            }
          },
          placeholder: 'Escribe el contenido...'
        });

        // ✅ Escuchar cambios en el editor para notificar al padre
        quillRef.current.on('text-change', () => {
          if (onChange) {
            onChange({
              isEditing: true,
              hasUnsavedChanges: true
            });
          }
        });

        // Agregar botón de archivo a la toolbar
        setTimeout(() => {
          const uploadButton = document.querySelector('.ql-upload-file');
          if (uploadButton) {
            uploadButton.innerHTML = '📎';
            uploadButton.setAttribute('title', 'Subir archivo');
            uploadButton.style.fontSize = '16px';
          }
        }, 100);

        // Establecer contenido inicial si existe
        if (contenido && Array.isArray(contenido)) {
          try {
            quillRef.current.setContents({ ops: contenido });
          } catch (error) {
            console.error('Error al establecer contenido inicial:', error);
          }
        }

        setQuillLoaded(true);
        console.log('✅ Quill inicializado correctamente');
      } catch (error) {
        console.error('❌ Error al cargar Quill:', error);
        alert('Error al cargar el editor: ' + error.message);
      }
    }
  };

  // Inicializar editor cuando entra en modo edición
  useEffect(() => {
    if (isEditing) {
      initQuill();
    }
    
    return () => {
      if (quillRef.current) {
        quillRef.current = null;
        setQuillLoaded(false);
      }
    };
  }, [isEditing]);

  // ✅ Función modificada para notificar el cambio de estado
  const handleEdit = () => {
    setIsEditing(true);
    // La notificación se hace automáticamente por el useEffect
  };

  const handleSave = async () => {
    if (!quillRef.current || !onSave) return;

    setLoading(true);
    try {
      const delta = quillRef.current.getContents();
      const deltaOps = delta.ops || [];
      
      console.log('💾 Guardando contenido:', deltaOps);
      
      await onSave(deltaOps);
      setIsEditing(false);
      
      // Actualizar vista con el nuevo contenido
      //procesado.current = false;
      const html = convertirQuillAHTML(deltaOps);
      //setHtmlContent(html);
      
      // ✅ Notificar que se guardó exitosamente
      if (onChange) {
        onChange({
          isEditing: false,
          hasUnsavedChanges: false
        });
      }
      
      console.log('✅ Contenido guardado exitosamente');
      
    } catch (error) {
      console.error('❌ Error al guardar:', error);
      alert('Error al guardar: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setIsEditing(false);
    setQuillLoaded(false);
    
    // ✅ Notificar que se canceló la edición
    if (onChange) {
      onChange({
        isEditing: false,
        hasUnsavedChanges: false
      });
    }
  };

  const htmlParaMostrar = convertirQuillAHTML(contenido);

  // Modo edición
  if (isEditing) {
    return (
      <div className="rich-content border rounded-md bg-white">
        {/* Toolbar de acciones */}
        <div className="flex items-center justify-between p-3 border-b bg-gray-50">
          <h4 className="font-medium text-gray-700">
            ✏️ Editando contenido
          </h4>
          <div className="flex items-center gap-2">
            <button
              onClick={handleCancel}
              className="px-3 py-1.5 text-sm bg-gray-100 text-gray-700 rounded hover:bg-gray-200 transition-colors flex items-center gap-1"
            >
              <X size={14} />
              Cancelar
            </button>
            <button
              onClick={handleSave}
              disabled={loading}
              className="px-3 py-1.5 text-sm bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors flex items-center gap-1 disabled:opacity-50"
            >
              {loading ? (
                <div className="animate-spin rounded-full h-3 w-3 border-b border-white"></div>
              ) : (
                <Save size={14} />
              )}
              {loading ? 'Guardando...' : 'Guardar'}
            </button>
          </div>
        </div>
        
        {/* Editor Quill */}
        <div className="p-4">
          <div ref={editorRef} style={{ minHeight: '200px' }} />
          {!quillLoaded && (
            <div className="text-center text-gray-500 py-8">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-2"></div>
              Cargando editor...
            </div>
          )}
        </div>

        {/* Input oculto para archivos */}
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleFileChange}
          style={{ display: 'none' }}
          accept="*/*"
        />
      </div>
    );
  }

  // Modo vista
  return (
    <div className="rich-content border rounded-md bg-white">
      {/* Header con botón de editar */}
      {isAdmin && editable && onSave && (
        <div className="flex items-center justify-between p-3 border-b bg-gray-50">
          <h4 className="font-medium text-gray-700">Contenido</h4>
          <button
            onClick={handleEdit}
            className="px-3 py-1.5 text-sm bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors flex items-center gap-1"
          >
            <Edit3 size={14} />
            Editar
          </button>
        </div>
      )}
      
      {/* Contenido */}
      <div 
        className="p-4 min-h-[100px]"
        dangerouslySetInnerHTML={{ __html: htmlParaMostrar }}
      />
      
      {/* Mensaje si no hay contenido */}
      {!htmlParaMostrar && (
        <div className="p-4 text-gray-500 text-center">
          <Eye size={24} className="mx-auto mb-2 opacity-50" />
          <p className="mb-3">
            {isAdmin && editable && onSave ? 'No hay contenido. Haz clic en "Editar" para agregar contenido.' : 'No hay contenido disponible.'}
          </p>
          {isAdmin && editable && onSave && (
            <button
              onClick={handleEdit}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors flex items-center gap-2 mx-auto"
            >
              <Edit3 size={16} />
              Agregar Contenido
            </button>
          )}
        </div>
      )}
    </div>
  );
});

ContenidoEnriquecido.displayName = 'ContenidoEnriquecido';

export default ContenidoEnriquecido;